module.exports = __webpack_public_path__ + "resources/img/logo_Loadcomplete.ee9faf4d9f240e4adee4b13311508956.png";